import type { TokenPosition } from "./auth";

/**
 * ตำแหน่ง (ADR-0030) — ชื่อตาม `positions` ที่ seed (migration 000048) ใช้แสดงผลในจอที่ไม่ได้โหลด matrix
 * (ผู้ใช้ส่วนใหญ่ไม่มี CFG-12/13 จึงเรียก `GET /v1/admin/permissions` ไม่ได้)
 */
export const POSITION_LABEL_LO: Record<TokenPosition, string> = {
  CIT: "ປະຊາຊົນ",
  VH: "ນາຍບ້ານ",
  TH: "ຫົວໜ້າ / ຮອງຫົວໜ້າຕາແສງ",
  TK: "ຜູ້ກວດເອກະສານ",
  TR: "ຜູ້ຮັບເລື່ອງ",
  TF: "ການເງິນ (ຕາແສງ)",
  DO: "ເຈົ້າໜ້າທີ່ເມືອງ",
  PO: "ເຈົ້າໜ້າທີ່ແຂວງ/ນະຄອນ",
  AD: "Admin (ແຂວງ)",
  SA: "SuperAdmin",
};

/** คำอธิบายสั้นของหน้าที่ — ใช้ใต้ตัวเลือกตำแหน่งในฟอร์มบัญชี */
export const POSITION_HINT_LO: Partial<Record<TokenPosition, string>> = {
  VH: "ໃຊ້ແອັບມືຖື — ຢັ້ງຢືນຄຳຮ້ອງຂອງບ້ານຕົນເອງ",
  TH: "ກວດ, ອະນຸມັດ ແລະ ເຊັນອອກເອກະສານໄດ້",
  TK: "ຮັບ, ກວດ, ສົ່ງຄືນແກ້ໄຂ ແລະ ອະນຸມັດ — ເຊັນບໍ່ໄດ້",
  TR: "ຮັບເລື່ອງບໍລິການເສີມ (ແຈ້ງເຫດ, ນັດປຶກສາ) — ບໍ່ເຫັນຄຳຮ້ອງເອກະສານເຕັມ",
  TF: "ເບິ່ງການເງິນຂອງຕາແສງ",
  DO: "ເບິ່ງຂໍ້ມູນ ແລະ ລາຍງານຂອງທຸກຕາແສງໃນເມືອງ",
  PO: "ເບິ່ງຂໍ້ມູນ ແລະ ລາຍງານທົ່ວແຂວງ",
  AD: "ຈັດການບັນຊີ ແລະ ສິດລາຍບຸກຄົນ ໃນແຂວງ",
};

export type StaffPosition = Exclude<TokenPosition, "CIT" | "SA">;

/** เขตที่ตำแหน่งต้องผูก — ตาม base role (ADR-0030 ข้อ 2) และสิ่งที่ `POST /v1/admin/staff` บังคับ */
export type PositionPlace = "village" | "tasaeng" | "district" | "province";

export const POSITION_PLACE: Record<StaffPosition, PositionPlace> = {
  VH: "village",
  TH: "tasaeng",
  TK: "tasaeng",
  TR: "tasaeng",
  TF: "tasaeng",
  DO: "district",
  PO: "province",
  AD: "province",
};

/** ลำดับแสดงผล (ตาม `sort` ของ seed) */
export const STAFF_POSITIONS: StaffPosition[] = ["VH", "TH", "TK", "TR", "TF", "DO", "PO", "AD"];

/**
 * กฎ D5 "ສ້າງໄດ້ສະເພາະຕຳແໜ່ງທີ່ຕ່ຳກວ່າ" — ต้องตรงกับ `manageablePositions` ใน `usecase/staff`
 * (server เช็คซ้ำพร้อม CFG-11 และ scope เสมอ)
 */
export const MANAGEABLE_POSITIONS: Partial<Record<TokenPosition, StaffPosition[]>> = {
  TH: ["VH"],
  DO: ["TH", "TK", "TR", "TF"],
  PO: ["TH", "TK", "TR", "TF", "DO"],
  AD: ["VH", "TH", "TK", "TR", "TF", "DO", "PO"],
  SA: ["VH", "TH", "TK", "TR", "TF", "DO", "PO", "AD"],
};

export function positionLabel(code: string | null | undefined): string {
  if (!code) return "—";
  return (POSITION_LABEL_LO as Record<string, string | undefined>)[code] ?? code;
}
